module.exports = __webpack_public_path__ + "media/images/logo_64-5cfd16e0.png";